import { preloadIcons } from './utils';

// components
import { registerAccordions } from './components/accordion';
import { registerCards } from './components/card';
import { registerNavMenu, registerNavSearch } from './components/nav';

// blocks
import { registerAccessibilityBlock } from './blocks/accessibilityReport';
import { registerContactBlock } from './blocks/contact';
import { registerVideoBlock } from './blocks/video';

// pages
import { registerSearchPage } from './pages/search';

// polyfills and styles
import 'smoothscroll-polyfill';
import 'focus-visible';
import '../Styles/style.css';

$(function () {
    // First preload all the icons and store in icon collection
    preloadIcons();

    // Register components
    registerAccordions();
    registerCards();
    registerNavMenu();
    registerNavSearch();

    // Blocks
    registerAccessibilityBlock();
    registerContactBlock();
    registerVideoBlock();

    // Pages
    registerSearchPage();

    /*
     * Scroll to top button (with IE polyfill)
     */
    $('#scroll-to-top').click((e: JQuery.ClickEvent) => {
        e.preventDefault();

        try {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        } catch (ex) {
            $(window).scrollTop(0);
        }
    });

    /*
     * Tab fix for annoying safari accessibility setting
     * Uses jQuery.tabbable to fix this, ugly hack
     * Could possibly look for a better fix in the future
     * Only use this hack for MacBooks (safari) as the issue only originates from here
     * As we want the browser to resolve the next tab target on it's own if it's capable to do so
     */
    function handleDocumentKeyDown(e: JQuery.KeyDownEvent): void {
        if (e.key == 'Tab') {
            e.preventDefault();

            if (e.shiftKey) {
                // @ts-ignore
                $.tabPrev();
            } else {
                // @ts-ignore
                $.tabNext();
            }
        }
    }

    const isMacLike = /^(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    if (isMacLike) {
        $(document).on('keydown', handleDocumentKeyDown);
    }
});

